export default "/static/build/visa.png";